<template lang="pug">
.campaign-survey(v-loading="loading")
  el-tooltip(
    :content="campaignSurvey.campaign_name"
    placement="top"
    :disabled="!shouldShowTooltip"
  )
    .title {{ campaignSurvey.campaign_name }}
  .status(:class="{'is-completed': campaignSurvey.is_completed}")
    div {{ campaignSurvey.is_completed === 0 ? $t('进行中') : $t('已完成') }}
  div ID: {{ campaignId }}
  template(v-if="showBudget")
    .item
      div {{ $t('项目类别') }}:
      div(
        :title="getCategoryName()"
        style="width: 200px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;"
      ) {{ getCategoryName() }}
    .item
      div {{ $t('上线时间') }}:
      div {{ campaignSurvey.start_date | formatDate }} ~ {{ campaignSurvey.end_date | formatDate }}
    .item(v-if="!isVendor")
      div {{ $t('预算') }}:
      div {{ campaignSurvey.budget | formatMoney }}
</template>

<script>
import { formatMoney, formatDate } from '@/umcc/util'
import db from '@/umcc/db'

export default {
  props: {
    id: {
      type: Number,
      isRequired: true
    },
    showBudget: {
      type: Boolean,
      default () {
        return true
      }
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    campaignSurvey () {
      return this.$store.state.campaign.campaignSurvey
    },
    isVendor () {
      return this.$store.state.common.user.is_vendor
    },
    isZh () {
      return db.lang === 'zh'
    },
    shouldShowTooltip () {
      return this.$store.state.campaign.campaignSurvey.campaign_name.length > 16
    },
    campaignId () {
      return this.$store.state.campaign.id
    }
  },
  watch: {
    id () {
      this.fetchData()
    }
  },
  filters: {
    formatMoney,
    formatDate,
    formatCategory (category) {
      return category ? category.split(',').join(', ') : '—'
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    getCategoryName () {
      const { category } = this.campaignSurvey
      if (category.length === 0) return '—'
      // if (this.isZh) return category.map(i => `${i.category_name_ch}(${i.category_name})`).join(', ')
      return category.map(i => i.category_name).join(', ')
    },
    async fetchData () {
      if (!this.id) return
      this.loading = true
      await this.$store.dispatch('campaign/updateCampaignSurvey')
      this.loading = false
    }
  }
}
</script>

<style lang="stylus">
.campaign-survey
  display flex
  margin 16px 0 18px
  align-items baseline
  > div
    display flex
    margin-right 40px
  .title
    font-size 20px
    font-weight 500
    margin-right 20px
    max-width 340px
    text-overflow ellipsis
    overflow hidden
    white-space nowrap
    display inline-block
  .status
    border-radius 9px
    background linear-gradient(to right, #41dcab, #83ded9)
    color #ffffff
    font-size 12px
    line-height 18px
    padding 0 3px
    margin-right 20px
    &.is-completed
      background linear-gradient(to right, #3370d2, #8dd1ea)
      color #ffffff
  .item
    font-size 12px
    color #808080
    > div:first-child
      margin-right 5px
</style>
